import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-orders-container-item-move-form',
  templateUrl: './orders-container-item-move-form.component.html',
  styleUrls: ['./orders-container-item-move-form.component.scss']
})
export class OrdersContainerItemMoveFormComponent implements OnInit {

  isFormLoading: boolean = false;
  moveItemsData: any;
  selectedContainer: any = null;
  containerList: any = [];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<OrdersContainerItemMoveFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.moveItemsData = this.data;
    this.containerList = this.moveItemsData.containers;
  }

  onSave() {
    if (!this.selectedContainer && this.selectedContainer !== 0) {
      this.toastr.error('Select the Container to move items.');
      return;
    }
    if (this.moveItemsData.items.length === 0){
      this.toastr.error('Opps, you not selected any item to move.');
      return;
    }
    const sendingData = {
      confirmResult: true,
      selectedContainer: this.selectedContainer
    };
    this.dialogRef.close(sendingData);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
